import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Box, Heading, VStack, IconButton, Flex, Button } from '@chakra-ui/react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

import { useStore } from '../../hooks/useStore';
import FlashListingSchedule from '../../components/schedule/FlashListingSchedule';

const EventScreen = () => {
  const { timeGroup, groupId } = useParams<{
    timeGroup: string;
    groupId: string;
  }>();
  const navigate = useNavigate();
  const {
    listingStore: {
      flashActiveListings,
      currentFlashEvent,
      updateFlashListingSchedule,
      getEventListings,
      bulkUpdateEventListings,
      loading,
    },
  } = useStore();

  const fetchListings = async () => {
    if (!timeGroup || !groupId) return;
    await getEventListings(Number(timeGroup), groupId);
  };

  const handleSaveSchedule = async () => {
    try {
      await bulkUpdateEventListings();
      await fetchListings();
    } catch (error) {
      console.error('Error saving schedule:', error);
    }
  };

  useEffect(() => {
    fetchListings();
  }, []);

  const formatDateTime = (timestamp: string) => {
    return new Date(Number(timestamp)).toLocaleString();
  };

  return (
    <Box p={6}>
      <VStack spacing={6} align="stretch">
        <Flex align="center" justify="space-between">
          <Flex align="center" gap={4}>
            <IconButton
              aria-label="Go back"
              icon={<FaArrowLeft />}
              variant="ghost"
              onClick={() => navigate(-1)}
            />
            {currentFlashEvent ? (
              <Heading size="lg">
                {currentFlashEvent?.title} -{' '}
                {currentFlashEvent?.metaTimes[0]
                  ? formatDateTime(
                      currentFlashEvent?.metaTimes[0].toString(),
                    )
                  : 'N/A'}
              </Heading>
            ) : null}
          </Flex>

          <Button
            colorScheme="blue"
            onClick={handleSaveSchedule}
            isLoading={loading}
            loadingText="Saving..."
          >
            Save Schedule
          </Button>
        </Flex>

        <FlashListingSchedule
          listings={flashActiveListings}
          onReorder={updateFlashListingSchedule}
          fetchListings={fetchListings}
        />
      </VStack>
    </Box>
  );
};

export default observer(EventScreen);
